<template>
  <span class="referential-score">
    <strong>{{ score }}</strong>
    <MetricInfoTooltip :content="REFERENTIAL_SCORE_HELP_TEXT" />
  </span>
</template>

<script>
import MetricInfoTooltip from "@/components/Levels/MetricInfoTooltip";
import { REFERENTIAL_SCORE_HELP_TEXT } from "@/utils/dailyMenuLevelHelpTexts";

export default {
  name: "ReferentialScore",
  components: {
    MetricInfoTooltip
  },
  props: {
    score: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    REFERENTIAL_SCORE_HELP_TEXT
  })
};
</script>

<style lang="scss" scoped>
.referential-score strong {
  color: #8a8a8a;
  font-style: italic;
}
</style>
